import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-lottrackr.svg'
import _imports_1 from '@/assets/icons/chevron-down.svg'
import _imports_2 from '@/assets/icons/icon-powered-by.svg'


const _withScopeId = n => (_pushScopeId("data-v-7d093395"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container-search" }
const _hoisted_2 = { class: "wrapper-burger" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "estate-map-wrapper-logo"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 2,
  class: "wrapper-input"
}
const _hoisted_12 = { class: "navigation" }
const _hoisted_13 = { class: "switch-item--text" }
const _hoisted_14 = {
  key: 1,
  class: "profile"
}
const _hoisted_15 = { class: "profile" }
const _hoisted_16 = { class: "profile-avatar" }
const _hoisted_17 = { class: "profile-name" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_19 = { class: "menu" }
const _hoisted_20 = {
  key: 1,
  class: "estate-map-header"
}
const _hoisted_21 = { class: "estate-map-wrapper-logo" }
const _hoisted_22 = {
  key: 0,
  class: "wrapper-burger"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  key: 0,
  class: "auth-actions"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "menu-title" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title red" }, "Log Out", -1))
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "menu-title" }
const _hoisted_36 = {
  key: 0,
  class: "wrapper-powered-by"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", [{ 'estate-header': $props.estate }, {'over-all': $props.overAll}]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-container", { container: $props.estate }])
    }, [
      ($setup.isLogged())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(["burger", { 'burger-active': $setup.showMobileMenu }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showMobileMenu = !$setup.showMobileMenu))
                }, _hoisted_6, 2)
              ]),
              (!$props.estate)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "wrapper-logo",
                    onClick: $setup.onLogo
                  }, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    ($props.estate?._id)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'EstateMap', params: { estateId: $setup.props.estate._id } }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", { src: $setup.logoUrl }, null, 8, _hoisted_10)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ])),
              (!$props.estate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (!$props.estate)
                ? (_openBlock(), _createBlock($setup["SwitchComponent"], {
                    class: "navigation-items-wr",
                    key: $setup.navigationKey,
                    modelValue: $setup.activeNavItem,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => (($setup.activeNavItem) = $event)),
                      $setup.onChangeNavidationItem
                    ],
                    list: $setup.getNormalizedNavigation,
                    customSwitches: ['active'],
                    slots: ['customSwitch']
                  }, {
                    customSwitch: _withCtx((item) => [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(item.label), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "list"]))
                : _createCommentVNode("", true),
              ($setup.isLogged())
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode($setup["DropDown"], { placement: "right bottom" }, {
                      control: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, _toDisplayString($setup.getFirstLetter($setup.getUser().firstName)), 1),
                          _createElementVNode("div", _hoisted_17, "Hi, " + _toDisplayString($setup.getUser().firstName), 1),
                          _hoisted_18
                        ])
                      ]),
                      dropdown: _withCtx(() => [
                        _createElementVNode("ul", _hoisted_19, [
                          ($props.estate)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                onClick: $setup.onMyAccount
                              }, "My Dashboard"))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", { onClick: $setup.onProfile }, "My Profile"),
                          _createElementVNode("li", { onClick: $setup.onLogout }, "Log Out")
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              (!$props.hideAuthButtons)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["burger", { 'burger-active': $setup.showMobileMenu }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showMobileMenu = !$setup.showMobileMenu))
                    }, _hoisted_26, 2)
                  ]))
                : _createCommentVNode("", true),
              ($props.estate?._id)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: { name: 'EstateMap', params: { estateId: $props.estate._id } }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", { src: $setup.logoUrl }, null, 8, _hoisted_27)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            (!$props.hideAuthButtons)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("button", {
                    class: "sign-in",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('login')))
                  }, "Log in"),
                  _createElementVNode("button", {
                    class: "button primary sign-up",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('register')))
                  }, "Create Account")
                ]))
              : _createCommentVNode("", true)
          ]))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mobile-menu", { show: $setup.showMobileMenu }])
    }, [
      _createElementVNode("ul", null, [
        ($setup.isLogged())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.customerNavigation, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "menu-item",
                  key: index,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showMobileMenu = false))
                }, [
                  _createVNode(_component_router_link, {
                    class: "menu-link",
                    to: item.link
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "menu-icon",
                        src: require(`@/assets/icons/${item.icon}`)
                      }, null, 8, _hoisted_29),
                      _createElementVNode("div", _hoisted_30, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128)),
              _createElementVNode("li", {
                class: "menu-item",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showMobileMenu = false))
              }, [
                _createElementVNode("div", {
                  class: "menu-link",
                  onClick: $setup.onLogout
                }, [
                  _createElementVNode("img", {
                    class: "menu-icon",
                    src: require('@/assets/icons/icon-logout.svg')
                  }, null, 8, _hoisted_31),
                  _hoisted_32
                ])
              ])
            ], 64))
          : (!$setup.isLogged() && !$props.hideAuthButtons)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.logOutCustomerNavigation, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "menu-item",
                  key: index
                }, [
                  _createElementVNode("div", {
                    class: "menu-link",
                    onClick: ($event: any) => ($setup.handleLogOutUserMenu(item.emit))
                  }, [
                    _createElementVNode("img", {
                      class: "menu-icon",
                      src: require(`@/assets/icons/${item.icon}`)
                    }, null, 8, _hoisted_34),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(item.label), 1)
                  ], 8, _hoisted_33)
                ]))
              }), 128))
            : _createCommentVNode("", true)
      ]),
      (!$setup.isLogged())
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}